export enum CourseStatus {
  DRAFT = 'DRAFT',
  CANCELLED = 'CANCELLED',
  PUBLISHED = 'PUBLISHED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
}

export enum CourseVisibility {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
}

export enum CourseLocation {
  REMOTE = 'Remote',
  VENUE = 'Venue',
  BOTH = 'Both',
}

export enum CourseModuleStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  /**
   * As per tech design, courses are created with a default course module
   * to simplify the coding required for courses.
   *
   * These default course modules would contain all null values for entity
   * fields, only identified by the status enum.
   */
  DEFAULT = 'DEFAULT',
}

export enum CoursePackageStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
  /**
   * As per tech design, courses are created with a default course package
   * to simplify the coding required for courses.
   *
   * These default course package would contain all null values for entity
   * fields, only identified by the status enum.
   */
  DEFAULT = 'DEFAULT',
}


export enum ModuleSortColumns {
  NAME = 'name',
  TYPE = 'type',
}

export enum ModuleStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}

export enum TrainerAccreditationStatus {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
}

export enum TrainerAccreditationSortColumns {
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  ACCREDITATION = 'accreditation',
  ACCREDITATION_ID = 'accreditationId',
  EXPIRY_DATE = 'expiryDate',
}

export enum CourseTrainerSortColumns {
  NAME = 'name',
  TYPE = 'type',
}

export enum CourseDetailLevel {
  MODULES = 'modules',
  PACKAGE = 'packages',
  DISCOUNTS = 'discounts',
  COMMUNICATION = 'communication',
  QUESTIONS = 'questions',
  PARTICIPANTS = 'participants',
  ATTENDANCE = 'attendance',
  TASKS = 'tasks',
}

export enum CourseSpecificGLATypes {
  ADMIN_FEE = 'administration fee',
}

export enum CourseSortColumns {
  NAME = 'courseName',
  TYPE = 'courseType',
  START_DATE = 'startDate',
  END_DATE = 'endDate',
  LOCATION = 'location',
  LICENSE = 'applicationId',
  PARTICIPANTS = 'participants',
}

export enum CourseLicenseTemplateSortColumns {
  NAME = 'name',
  PRODUCT = 'product',
}

export enum CourseAttributeSortColumns {
  ATTRIBUTE_LABEL = 'attributeLabel',
  CONTENT_TYPE = 'contentType',
  GROUP_COUNT = 'groupCount',
}
